import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgVisibleFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 18C6.48 18 2 12 2 12C2 12 6.48 6 12 6C17.52 6 22 12 22 12C22 12 17.52 18 12 18ZM8.3 12C8.3 9.95655 9.95655 8.3 12 8.3C14.0435 8.3 15.7 9.95655 15.7 12C15.7 14.0435 14.0435 15.7 12 15.7C9.95655 15.7 8.3 14.0435 8.3 12ZM14.5 12C14.5 13.3807 13.3807 14.5 12 14.5C10.6193 14.5 9.5 13.3807 9.5 12C9.5 10.6193 10.6193 9.5 12 9.5C13.3807 9.5 14.5 10.6193 14.5 12Z",
		fill: "currentColor"
	})
});
export default SvgVisibleFill;
